import Stack from '@mui/material/Stack';
import { PageContext, SectionContext } from '@/analytics/analytics.types';
import DislikeButton from './DislikeButton';
import ForYouCardFavoriteHeart from './ForYouCardFavoriteHeart';

type Props = {
  analyticsInfo?: { context?: PageContext & SectionContext };
  isFavorite: boolean;
  listingId: number;
};

export default function ForYouActionButtons({
  analyticsInfo,
  isFavorite,
  listingId,
}: Props): JSX.Element {
  return (
    <Stack bottom={-16} direction="row" gap={1} position="absolute" right={8}>
      <DislikeButton analyticsInfo={analyticsInfo} listingId={listingId} />
      <ForYouCardFavoriteHeart
        listingId={listingId}
        isFavorite={isFavorite}
        analyticsInfo={analyticsInfo}
      />
    </Stack>
  );
}
